module.exports = __webpack_public_path__ + "static/img/stripe-payment.515b7807.png";